export const AppRoutes = {
    InterestOnBalance: 'balance-interest/personal',
    InterestOnBalanceOnboarding: 'balance-interest-onboarding/personal',
    BalanceInterestIdentification: 'balance-interest-identification',
}